import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { MapUtils } from '../utils/map.utils'

export class Zone {
    vectorLayer: VectorLayer<VectorSource>
    exclusionLayer: VectorLayer<VectorSource>
    panneauLayer: VectorLayer<VectorSource>
    colorSurface: string
    color: string
    typeVehiculeParking?: string

    constructor(colorSurface: string, color: string) {
        this.color = color
        this.colorSurface = colorSurface
        this.exclusionLayer = MapUtils.buildExclusionLayer(color)
        this.panneauLayer = MapUtils.buildPanneauLayer(color)
        this.vectorLayer = MapUtils.buildVectorLayer(
            color,
            colorSurface,
            () => this.panneauLayer.getSource().getFeatures().length > 0
        )
        // Re-rendre la couche surface quand les panneaux apparaissent/disparaissent
        // pour basculer entre style "motif panneau" et style plat.
        this.panneauLayer.getSource().on('change', () => this.vectorLayer.changed())
    }
}
